import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { singularityStore } from "@/store/store";
import { breakdanceUndo } from "@/lib/undo/undo";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import { SingularityBrandV } from "@/types/singularity/brand";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import defensiveCopy from "@/util/defensive-copy";
import { globalStore, uiStore } from "@/store/store";
import lodash from "lodash";

export async function fetchBrandSettings() {
  const settings = await makeWordPressAjaxRequest({
    action: "breakdance_singularity_get_brand_settings",
    decoder: SingularityBrandV,
    suppressErrorLogging: true
  });

  return pipe(
    settings,
    fold(
      () => false,
      loadedData => {
        breakdanceUndo.ignore(() => {
          singularityStore.setBrand(loadedData);
        });
        return true;
      }
    )
  );
}

export async function saveBrandSettings() {
  const settings = singularityStore.brand;

  const request = await makeWordPressAjaxRequest({
    action: "breakdance_singularity_save_brand_settings",
    dataToPost: {
      settings: fpJsonStringify(settings)
    },
    decoder: SingularityBrandV
  });

  return pipe(
    request,
    fold(
      () => false,
      () => true
    )
  );
}

export function updateGlobalSettings(
  paths: string | string[],
  value: any
): void {
  const pathArray = Array.isArray(paths) ? paths : [paths];

  pathArray.forEach(path => {
    const currentValue = lodash.get(globalStore.globalSettings, path);
    const copy = defensiveCopy(currentValue);

    const payload = {
      path,
      value: {
        ...copy,
        ...value
      }
    };

    globalStore.updateGlobalSettingsPerPath({ path, value: payload.value });
  });

  uiStore.setUnsavedChangesPresent(true);
}
